export class EnterpriseTypes {
    public static PERSONAL = 10000;
}
